import React from 'react';
import styles from './toggle-button.module.css';

type ToggleButtonProperties = {
  value: string;
  selected: boolean;
  disabled?: boolean;
  buttonStyle?: object;
  onSelected?: (...args: any) => void;
};

export default function ToggleButton(props: ToggleButtonProperties) {
  const { value, selected, disabled, onSelected, buttonStyle } = props;
  let classes = `${styles['toggle-button']} ${styles['medium']} font-pencil details-sb`;
  if (selected) {
    classes += ` ${styles.selected}`;
  }

  return (
    <button
      onClick={onSelected}
      className={classes}
      style={buttonStyle}
      aria-pressed={selected}
      disabled={disabled}
    >
      {value}
    </button>
  );
}
